import { Children, useEffect, useState } from 'react'
import { Container } from '../../../shared/Components/Container/Container'
import { ElementBreadCrumb } from '../../../shared/Components/ElementBreadCrumb'
import { LanguageTranslate } from '../../../shared/Infraestructure/LanguageTranslate'
import { useSelector } from 'react-redux'
import { RootState } from '../../../shared/Infraestructure/AdapterStore'
import { Card } from './card'
import ButtonFloating from '../../../shared/Components/ButtonFloating/ButtonFloating'
import { InputSearch } from '../../../shared/Components/ReactBootstrap/InputSearch/InputSearch'
import { AdapterGenerico } from '../../../shared/Infraestructure/AdapterGenerico'
import { ViewLoading } from '../../../shared/Components/ViewLoading'
import { ViewError } from '../../../shared/Components/ViewError'
import { useStockAlmacenRepository } from '../../../shared/Infraestructure/hooks'

export const ViewMain = () => {
    const { user } = useSelector((state: RootState) => state.auth)
    const languageTranslate = LanguageTranslate()
    const [searchTerm, setSearchTerm] = useState<string>('')
    const { data, isLoading, loadData, isError, error } = useStockAlmacenRepository(true)

    const getDataStockAlmacen = async () => {
        try {
            const pipeline = [{
                $match: {
                    'Almacen.Codigo': user.AlmacenEmpresa.Codigo,
                    'TipoStock.Nombre': 'NUEVO',
                    'Estado.ID_Estado': 2,
                    'Item.GranFamiliaItem.Nombre': 'SOMACYL',
                }
            }]
            await loadData({ pipeline })
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    useEffect(() => {
        getDataStockAlmacen()
    }, [])

    if (isLoading) return <ViewLoading />
    if (isError) return <ViewError error={error} />

    return (
        <Container>
            <ElementBreadCrumb
                list={
                    [
                        { text: languageTranslate.moduloMain.textoLogistica, navigate: true, path: '/main/logistica' },
                        { text: languageTranslate.menu['056'].titulo, navigate: false, path: `` }
                    ]
                }
            />
            <InputSearch handleChange={(text) => setSearchTerm(text)} textLength={1} />
            {
                Children.toArray(
                    (data ?? [])
                        .filter(e =>
                            `${e.Item.Codigo} ${e.Item.Descripcion}`
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase())
                        )
                        .map(sa => (
                            <Card item={sa} />
                        ))
                )
            }
            <ButtonFloating
                onClick={getDataStockAlmacen}
                icono='fa-solid fa-arrows-rotate'
                colorIcono='#2C3E50'
            />
        </Container>
    )
}